import { gbPromise, gb } from 'src/common/growthbook';
import { readStoredCampaigns } from 'src/features/campaigns/helpers/campaign-storage';

import { INFLUENCER_ADDITIONAL_CONFIGS, isInfluencerCampaignKey } from '../influencers.config';

export async function checkIsInInfluencersCampaign() {
  const storedCampaignName = readStoredCampaigns().activeCampaign?.name;

  if (!storedCampaignName || !isInfluencerCampaignKey(storedCampaignName)) {
    return false;
  }

  const config = INFLUENCER_ADDITIONAL_CONFIGS[storedCampaignName];

  if (!config) {
    return false;
  }

  const { page, featureFlag } = config;

  const campaignPage = !window.location.pathname.includes('/details') && window.location.pathname.includes(page);
  await gbPromise;
  const featureFlagValue = gb.isOn(featureFlag);
  const isInfluencerCampaign = featureFlagValue && campaignPage;

  return isInfluencerCampaign;
}
